<div *ngIf="userProfile">
    <a mat-stroked-button href="{{ profileUrl }}">
        {{ userProfile.email }}
    </a>

    <a mat-stroked-button *ngIf="logoutUrl" href="{{ logoutUrl }}">Logout</a>
</div>

<div *ngIf="!userProfile">Not logged in.</div>
